










import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "credit-notes-table": () =>
      import("@/components/app/global/creditNotes/creditNotesTable.vue")
  }
})
export default class ClientCreditNotes extends Vue {}
